export default "__VITE_ASSET__BO5FOWvS__"